<template>

    <div class="button-settings">

        <!-- normal & hover tabs -->
        <b-tabs pills class="button-state-tabs">

            <!-- settings normal state -->
            <b-tab title="Normal" active>

                <!-- settings group: CONTENT -->
                <div class="settings-group-title">
                    <h6>content</h6>
                </div>

                <div class="settings-group">

                    
                    <div class="setting">
                        <label for="titleTag">Heading tag:</label>

                        <b-form-select id="titleTag" v-model="settingsFromWeebly.settings.titleTag" size="sm">
                            <option value="h1">H1</option>
                            <option value="h2">H2</option>
                            <option value="h3">H3</option>
                            <option value="h4">H4</option>
                            <option value="h5">H5</option>
                            <option value="h6">H6</option>
                            <option value="p">P</option>
                            <option value="div">DIV</option>
                        </b-form-select>

                    </div>

                    <!-- font family -->
                    <div class="setting" v-show="deviceStylesSetttings.desktopStyles && !settingsFromWeebly.settings.useCustomFont">
                        <b-form-group>
                            <div style="display: flex">
                                <label for="" style="flex:1;padding-right:5px;">Font family:</label>
                                <i class="fas fa-font" style="cursor:pointer" v-b-modal="'FontLibraryClient'" v-b-tooltip.hover.top title="My Font Library"></i>
                            </div>
                            <b-form-select :options="googleFontsArray" @change="applyFont" v-model="settingsFromWeebly.settings.fontGoogleLoad" size="sm" />
                        </b-form-group>
                    </div>

                

                    

                    <!-- custom font family -->
                    <div class="setting" v-show="deviceStylesSetttings.desktopStyles">
                        <b-form-checkbox switch v-model="settingsFromWeebly.settings.useCustomFont" name="use-custom-font">
                            Use custom font
                        </b-form-checkbox>
                    </div>
    
                    <div class="setting" v-show="deviceStylesSetttings.desktopStyles && settingsFromWeebly.settings.useCustomFont" style="background: #fafbfd;padding: 10px; border: 1px solid #D8DDE5;">
                        <b-form-group>

                            <div class="setting">
                                <label for="button-customFontName">Custom font name: <i style="margin-left:7px;" class="far fa-question-circle" v-b-tooltip.hover="{title: 'Make sure to add the exact correct name', placement: 'top', boundary: 'window'}"></i></label>

                                <b-form-input id="button-customFontName" type="text" v-model="settingsFromWeebly.settings.customFontName" size="sm" />
                            </div>

                            <div class="setting">
                                <label for="button-customFontWeight">Custom font weight: <i style="margin-left:7px;" class="far fa-question-circle" v-b-tooltip.hover="{title: 'Only select a weight the weight you are loading the files for', placement: 'top', boundary: 'window'}"></i></label>

                                <b-form-select id="button-customFontWeight" v-model="settingsFromWeebly.settings.customFontWeight" size="sm">
                                    <option value="100">Thin - 100</option>
                                    <option value="200">Extra-LIght - 200</option>
                                    <option value="300">Light - 300</option>
                                    <option value="400">Regular - 400</option>
                                    <option value="500">Medium - 500</option>
                                    <option value="600">Semi-Bold - 600</option>
                                    <option value="700">Bold - 700</option>
                                    <option value="800">Extra-Bold - 800</option>
                                    <option value="900">Black - 900</option>
                                </b-form-select>

                            </div>

                            <div class="setting">
                                <label for="button-customFontStyle">Custom font style: <i style="margin-left:7px;" class="far fa-question-circle" v-b-tooltip.hover="{title: 'Use italic if you have this option available', placement: 'top', boundary: 'window'}"></i></label>
                                <b-form-select id="button-customFontStyle" v-model="settingsFromWeebly.settings.customFontStyle" size="sm">
                                    <option value="normal">Normal</option>
                                    <option value="italic">Italic</option>
                                </b-form-select>
                            </div>

                        </b-form-group>
                    </div>

                    <!-- font size button text desktop -->
                    <div class="setting">
                        <b-form-group v-show="deviceStylesSetttings.desktopStyles">

                            <label for="button-fontsize-input">Font size:</label>
                            
                            <b-input-group append="px" size="sm">
                                <b-form-input id="button-fontsize-input" type="number" v-model="settingsFromWeebly.settings.buttonTextFontSize" min="5" />
                            </b-input-group>

                        </b-form-group>
                    </div>

                    <!-- font size button text tablet -->
                    <div class="setting">
                        <b-form-group v-show="deviceStylesSetttings.tabletStyles">

                            <label for="button-fontsize-tablet-input">Font size tablet:</label>
                            
                            <b-input-group append="px" size="sm">
                                <b-form-input id="button-fontsize-tablet-input" type="number" v-model="settingsFromWeebly.settings.buttonTextFontSizeTablet" min="5" />
                            </b-input-group>

                        </b-form-group>
                    </div>

                    <!-- font size button text phone -->
                    <div class="setting">
                        <b-form-group v-show="deviceStylesSetttings.mobileStyles">

                            <label for="button-fontsize-phone-input">Font size phone:</label>
                            
                            <b-input-group append="px" size="sm">
                                <b-form-input id="button-fontsize-phone-input" type="number" v-model="settingsFromWeebly.settings.buttonTextFontSizePhone" min="5" />
                            </b-input-group>

                        </b-form-group>
                    </div>

                    <!-- text color normal state -->
                    <div class="setting" v-show="deviceStylesSetttings.desktopStyles">
                        <Mycolorpicker elementRef="textColor" theColorPicker="allpickers" colorPickerName="Text color:" />
                    </div>

                    <!-- letter spacing DESKTOP -->
                    <div class="setting" v-show="deviceStylesSetttings.desktopStyles">
                        <b-form-group>

                            <label for="button-letterspacing-input">Letter spacing:</label>

                            <b-input-group append="px" size="sm">
                                <b-form-input id="button-letterspacing-input" type="number" v-model="settingsFromWeebly.settings.letterSpacing" min="-5" />
                            </b-input-group>

                        </b-form-group>
                    </div>

                    <!-- letter spacing TABLET -->
                    <div class="setting" v-show="deviceStylesSetttings.tabletStyles">
                        <b-form-group>

                            <label for="button-letterspacing-tablet-input">Letter spacing tablet:</label>

                            <b-input-group append="px" size="sm">
                                <b-form-input id="button-letterspacing-tablet-input" type="number" v-model="settingsFromWeebly.settings.letterSpacingTablet" min="-5" />
                            </b-input-group>

                        </b-form-group>
                    </div>

                    <!-- letter spacing PHONE -->
                    <div class="setting" v-show="deviceStylesSetttings.mobileStyles">
                        <b-form-group>

                            <label for="button-letterspacing-phone-input">Letter spacing phone:</label>

                            <b-input-group append="px" size="sm">
                                <b-form-input id="button-letterspacing-phone-input" type="number" v-model="settingsFromWeebly.settings.letterSpacingPhone" min="-5" />
                            </b-input-group>

                        </b-form-group>
                    </div>

                    <!-- line height DESKTOP -->
                    <div class="setting" v-show="deviceStylesSetttings.desktopStyles">
                        <b-form-group>

                            <label for="button-lineheight-input">Line height:</label>

                            <b-input-group append="em" size="sm">
                                <b-form-input id="button-lineheight-input" type="number" v-model="settingsFromWeebly.settings.lineHeight" min="1" step="0.1" />
                            </b-input-group>

                        </b-form-group>
                    </div>

                    <!-- line height TABLET -->
                    <div class="setting" v-show="deviceStylesSetttings.tabletStyles">
                        <b-form-group>

                            <label for="button-lineheight-tablet-input">Line height tablet:</label>

                            <b-input-group append="em" size="sm">
                                <b-form-input id="button-lineheight-tablet-input" type="number" v-model="settingsFromWeebly.settings.lineHeightTablet" min="1" step="0.1" />
                            </b-input-group>

                        </b-form-group>
                    </div>

                    <!-- line height PHONE -->
                    <div class="setting" v-show="deviceStylesSetttings.mobileStyles">
                        <b-form-group>

                            <label for="button-lineheight-phone-input">Line height:</label>

                            <b-input-group append="em" size="sm">
                                <b-form-input id="button-lineheight-phone-input" type="number" v-model="settingsFromWeebly.settings.lineHeightPhone" min="1" step="0.1" />
                            </b-input-group>

                        </b-form-group>
                    </div>

                    <!-- use as link -->
                    <div class="setting" v-if="deviceStylesSetttings.desktopStyles && clientPro=='PRO'">
                        <b-form-checkbox switch v-model="settingsFromWeebly.settings.linkTitle" name="use-custom-font">
                            Link title
                        </b-form-checkbox>
                    </div>

                    <!-- use as link free -->
                    <div class="setting pro-setting" v-if="deviceStylesSetttings.desktopStyles && clientPro!=='PRO'" v-b-tooltip.hover.top title="PRO feature" v-b-modal="'upgrades-modal'">
                        <b-form-checkbox switch name="use-custom-font" disabled>
                            Link title
                        </b-form-checkbox>
                    </div>

                    <div v-if="settingsFromWeebly.settings.linkTitle">
                        <!-- button url -->
                        <div class="setting" v-show="deviceStylesSetttings.desktopStyles">
                            <b-form-group label="Button link:" label-for="button-url-input">

                                <!-- extra settings toggle -->
                                <span class="input-right-setting-icon button-target-settings-box-trigger" @click="targetSettingsBox = !targetSettingsBox" v-b-tooltip.hover.top title="Link Options">
                                    <i class="fas fa-cog"></i>
                                </span>

                                <b-form-input id="button-url-input" type="text"  class="input-with-right-setting-icon" v-model="settingsFromWeebly.settings.buttonHref" size="sm" />

                            </b-form-group>
                            <div v-show="targetSettingsBox">

                            <!-- button target -->
                            <b-form-radio-group label="Open link in:" label-for="button-target-select" v-model="settingsFromWeebly.settings.buttonTarget" id="button-target-select">
                                    
                                    <b-form-radio value="_self" name="button-target">Open in same window</b-form-radio>

                                    <b-form-radio value="_blank" name="button-target">Open in new window</b-form-radio>

                                </b-form-radio-group>

                            </div>
                        </div>
                    </div>

                    <!-- checkbox use icon -->
                    <div class="setting" v-if="deviceStylesSetttings.desktopStyles && clientPro=='PRO'">
                        <b-form-checkbox switch v-model="settingsFromWeebly.settings.useIcon" name="use-icon">
                            Use icon
                        </b-form-checkbox>
                    </div>

                    <!-- checkbox use icon free -->
                    <div class="setting pro-setting" v-if="deviceStylesSetttings.desktopStyles && clientPro!=='PRO'" v-b-tooltip.hover.top title="PRO feature" v-b-modal="'upgrades-modal'">
                        <b-form-checkbox switch name="use-icon" disabled>
                            Use icon
                        </b-form-checkbox>
                    </div>

                    <!-- select icon -->
                    <div class="setting" v-show="deviceStylesSetttings.desktopStyles">
                        <MyIconPicker v-if="settingsFromWeebly.settings.useIcon" :setActiveIcon="settingsFromWeebly.settings.iconClass" asToggleBox="true" />
                    </div>

                    <!-- icon position -->
                    <div class="setting" v-show="deviceStylesSetttings.desktopStyles">
                        <b-form-group label="Icon position:" v-if="settingsFromWeebly.settings.useIcon">
                            
                            <b-form-select @change="iconPositionUpdate" v-model="settingsFromWeebly.settings.iconPosition" size="sm">

                                <option value="useIconBefore">Before text</option>
                                <option value="useIconAfter">After text</option>

                            </b-form-select>

                        </b-form-group>
                    </div>

                    <!-- Icon spacing: text <=> icon -->
                    <div class="setting" v-show="deviceStylesSetttings.desktopStyles">
                        <b-form-group v-if="settingsFromWeebly.settings.useIcon">

                            <label for="button-iconspace-input">Icon spacing:</label>
                            <b-input-group append="px" size="sm">
                                <b-form-input id="button-iconspace-input" type="number" v-model="settingsFromWeebly.settings.iconMargin" min="0" />
                            </b-input-group>

                        </b-form-group>
                    </div>
                </div><!-- settings group -->

                <!-- settings group: DIMENSTIONS -->
                <div class="settings-group-title">
                    <h6>spacing</h6>
                </div>

                <div class="settings-group">

                    <!-- margin top button DESKTOP -->
                    <div class="setting" v-show="deviceStylesSetttings.desktopStyles">
                        <b-form-group label="Margin above button:" label-for="button-margintop-input">
                            
                            <b-input-group append="px" size="sm">
                                <b-form-input id="button-margintop-input" type="number" v-model="settingsFromWeebly.settings.buttonMarginTop" min="0" />
                            </b-input-group>

                        </b-form-group>
                    </div>

                    <!-- margin bottom button DESKTOP -->
                    <div class="setting" v-show="deviceStylesSetttings.desktopStyles">
                        <b-form-group label="Margin under button:" label-for="button-marginbottom-input">

                            <b-input-group append="px" size="sm">
                                <b-form-input id="button-marginbottom-input" type="number" v-model="settingsFromWeebly.settings.buttonMarginBottom" min="0" />
                            </b-input-group>

                        </b-form-group>
                    </div>

                    <!-- vertical padding button DESKTOP -->
                    <div class="setting" v-show="deviceStylesSetttings.desktopStyles">
                        <b-form-group label="Vertical padding:" label-for="button-verticalpadding-input">
                            
                            <b-input-group append="px" size="sm">
                                <b-form-input id="button-verticalpadding-input" type="number" v-model="settingsFromWeebly.settings.buttonPaddingVertical" min="0" />
                            </b-input-group>

                        </b-form-group>
                    </div>

                    <!-- horizontal padding button DESKTOP -->
                    <div class="setting" v-show="deviceStylesSetttings.desktopStyles">
                        <b-form-group label="Horizontal padding:" label-for="button-horizontalpadding-input">

                            <b-input-group append="px" size="sm">
                                <b-form-input id="button-horizontalpadding-input" type="number" v-model="settingsFromWeebly.settings.buttonPaddingHorizontal" min="0" />
                            </b-input-group>

                        </b-form-group>
                    </div>

                    <!-- vertical padding button TABLET -->
                    <div class="setting" v-show="deviceStylesSetttings.tabletStyles">
                        <b-form-group label="Vertical padding Tablet:" label-for="button-verticalpadding-tablet-input">
                            
                            <b-input-group append="px" size="sm">
                                <b-form-input id="button-verticalpadding-tablet-input" type="number" v-model="settingsFromWeebly.settings.buttonPaddingVerticalTablet" min="0" />
                            </b-input-group>

                        </b-form-group>
                    </div>

                    <!-- horizontal padding button TABLET -->
                    <div class="setting" v-show="deviceStylesSetttings.tabletStyles">
                        <b-form-group label="Horizontal padding Tablet:" label-for="button-horizontalpadding-tablet-input">

                            <b-input-group append="px" size="sm">
                                <b-form-input id="button-horizontalpadding-tablet-input" type="number" v-model="settingsFromWeebly.settings.buttonPaddingHorizontalTablet" min="0" />
                            </b-input-group>

                        </b-form-group>
                    </div>

                    <!-- vertical padding button PHONE -->
                    <div class="setting" v-show="deviceStylesSetttings.mobileStyles">
                        <b-form-group label="Vertical padding Phone:" label-for="button-verticalpadding-phone-input">
                            
                            <b-input-group append="px" size="sm">
                                <b-form-input id="button-verticalpadding-phone-input" type="number" v-model="settingsFromWeebly.settings.buttonPaddingVerticalPhone" min="0" />
                            </b-input-group>

                        </b-form-group>
                    </div>

                    <!-- horizontal padding button PHONE -->
                    <div class="setting" v-show="deviceStylesSetttings.mobileStyles">
                        <b-form-group label="Horizontal padding Phone:" label-for="button-horizontalpadding-phone-input">

                            <b-input-group append="px" size="sm">
                                <b-form-input id="button-horizontalpadding-phone-input" type="number" v-model="settingsFromWeebly.settings.buttonPaddingHorizontalPhone" min="0" />
                            </b-input-group>

                        </b-form-group>
                    </div>

                     <!-- align button DESKTOP -->
                    <div class="setting" v-show="deviceStylesSetttings.desktopStyles">
                        <label for="">Button align:</label>
                        <b-form-radio-group buttons class="alignment-radios" size="md" v-model="settingsFromWeebly.settings.buttonAlignement">
                            <b-form-radio value="left"  name="desktop-button-aligment"><i class="fas fa-align-left"></i></b-form-radio>
                            <b-form-radio value="center"  name="desktop-button-aligment"><i class="fas fa-align-center"></i></b-form-radio>
                            <b-form-radio value="right"  name="desktop-button-aligment"><i class="fas fa-align-right"></i></b-form-radio>
                        </b-form-radio-group>
                    </div>

                    <!-- align button TABLET -->
                    <div class="setting" v-show="deviceStylesSetttings.tabletStyles">
                        <label for="">Button align:</label>
                        <b-form-radio-group buttons class="alignment-radios" size="md" v-model="settingsFromWeebly.settings.buttonAlignementTablet">
                            <b-form-radio value="left"  name="tablet-button-aligment"><i class="fas fa-align-left"></i></b-form-radio>
                            <b-form-radio value="center"  name="tablet-button-aligment"><i class="fas fa-align-center"></i></b-form-radio>
                            <b-form-radio value="right"  name="tablet-button-aligment"><i class="fas fa-align-right"></i></b-form-radio>
                        </b-form-radio-group>
                    </div>

                    <!-- align button PHONE -->
                    <div class="setting" v-show="deviceStylesSetttings.mobileStyles">
                        <label for="">Button align:</label>
                        <b-form-radio-group buttons class="alignment-radios" size="md" v-model="settingsFromWeebly.settings.buttonAlignementPhone">
                            <b-form-radio value="left"  name="phone-button-aligment"><i class="fas fa-align-left"></i></b-form-radio>
                            <b-form-radio value="center"  name="phone-button-aligment"><i class="fas fa-align-center"></i></b-form-radio>
                            <b-form-radio value="right"  name="phone-button-aligment"><i class="fas fa-align-right"></i></b-form-radio>
                        </b-form-radio-group>
                    </div>
                
                </div><!-- settings group -->

                <!-- settings group: STYLE -->
                <div class="settings-group-title">
                    <h6>style</h6>
                </div>
               
                <div class="settings-group" v-show="deviceStylesSetttings.desktopStyles">
                    <!-- background color normal state -->
                    <div class="setting" >
                        <Mycolorpicker elementRef="buttonBg" theColorPicker="allpickers" colorPickerName="Background color:" />
                    </div>

                    <!-- use border parent -->
                    <div class="setting">
                        <b-form-checkbox switch v-model="settingsFromWeebly.settings.useBorderParent" name="parent-use-border">
                            Apply border
                        </b-form-checkbox>
                    </div>

                    <div v-if="!settingsFromWeebly.settings.useIndividualBorder && settingsFromWeebly.settings.useBorderParent">

                        <div class="border-group">

                            <div class="border-group--title">
                                Border desktop
                            </div>
                            <i class="fas unlink-border-radius fa-link" @click="settingsFromWeebly.settings.useIndividualBorder = !settingsFromWeebly.settings.useIndividualBorder" v-b-tooltip.hover.top title="Set borders individually"></i>

                            <!--  general border width DESKTOP -->
                            <div class="setting">
                                <b-form-group>

                                    <label for="flexparent-generalborderwidth-input">Width:</label>
                                    
                                    <b-input-group append="px" size="sm">
                                        <b-form-input id="flexparent-generalborderwidth-input" type="number" v-model="settingsFromWeebly.settings.parentBorderWidth" min="0" />
                                    </b-input-group>

                                </b-form-group>
                            </div>   

                            <!--  general border color -->
                            <div class="setting">
                                <Mycolorpicker elementRef="parentBorderColor" theColorPicker="allpickers" colorPickerName="Color:" />
                            </div>

                            <!-- border type general -->
                            <div class="setting">
                                <b-form-group label="Style:">

                                    <b-form-select v-model="settingsFromWeebly.settings.parentBorderType" size="sm">

                                        <option value="solid">Solid</option>

                                        <option value="dotted">Dotted</option>

                                        <option value="dashed">Dashed</option>

                                        <option value="double">Double</option>

                                    </b-form-select>

                                </b-form-group>
                            </div>

                        </div><!-- border-group -->
                        
                    </div><!-- v-if="!parent.useIndividualBorder" -->

                    <div v-if="settingsFromWeebly.settings.useIndividualBorder && settingsFromWeebly.settings.useBorderParent">
                        
                        <!-- border colors and width and type -->
                        <div class="border-group">

                            <div class="border-group--title">
                                Border top desktop
                            </div>
                            <i class="fas unlink-border-radius fa-unlink" @click="settingsFromWeebly.settings.useIndividualBorder = !settingsFromWeebly.settings.useIndividualBorder" v-b-tooltip.hover.top title="Set borders equally"></i>
                        
                            <!--  border top width DESKTOP -->
                            <div class="setting">
                                <b-form-group>

                                    <label for="flexparent-generalborderwidth-input">Border top width desktop:</label>
                                    
                                    <b-input-group append="px" size="sm">
                                        <b-form-input id="flexparent-generalborderwidth-input" type="number" v-model="settingsFromWeebly.settings.borderTopWidthParent" min="0" />
                                    </b-input-group>

                                </b-form-group>
                            </div>   

                            <!--  border top color -->
                            <div class="setting">
                                <Mycolorpicker elementRef="borderTopColorParent" theColorPicker="allpickers" colorPickerName="Border top color:" />
                            </div>

                            <!-- border top type -->
                            <div class="setting">
                                <b-form-group label="Border top style:">

                                    <b-form-select v-model="settingsFromWeebly.settings.borderTopStyleParent" size="sm">

                                        <option value="solid">solid</option>

                                        <option value="dotted">dotted</option>

                                        <option value="dashed">dashed</option>

                                        <option value="double">double</option>

                                    </b-form-select>

                                </b-form-group>
                            </div>

                        </div><!-- border-group -->

                        <!-- border radius individual -->
                        <div class="border-group">

                            <div class="border-group--title">
                                Border right desktop
                            </div>

                            <!--  border right width DESKTOP -->
                            <div class="setting">
                                <b-form-group>

                                    <label for="flexparent-borderRightWidthDesk-input">Width:</label>
                                    
                                    <b-input-group append="px" size="sm">
                                        <b-form-input id="flexparent-borderRightWidthDesk-input" type="number" v-model="settingsFromWeebly.settings.borderRightWidthParent" min="0" />
                                    </b-input-group>

                                </b-form-group>
                            </div>   

                            <!--  border right color -->
                            <div class="setting">
                                <Mycolorpicker elementRef="borderRightColorParent" theColorPicker="allpickers" colorPickerName="Color:" />
                            </div>

                            <!-- border right type -->
                            <div class="setting">
                                <b-form-group label="Style:">

                                    <b-form-select v-model="settingsFromWeebly.settings.borderRightStyleParent" size="sm">

                                        <option value="solid">solid</option>

                                        <option value="dotted">dotted</option>

                                        <option value="dashed">dashed</option>

                                        <option value="double">double</option>

                                    </b-form-select>

                                </b-form-group>
                            </div>
                        
                        </div><!-- border-group -->

                        <div class="border-group">

                            <div class="border-group--title">
                                Border bottom desktop
                            </div>
                            <!--  border bottom width DESKTOP -->
                            <div class="setting">
                                <b-form-group>

                                    <label for="flexparent-borderBottomWidth-input">Width:</label>
                                    
                                    <b-input-group append="px" size="sm">
                                        <b-form-input id="flexparent-borderBottomWidth-input" type="number" v-model="settingsFromWeebly.settings.borderBottomWidthParent" min="0" />
                                    </b-input-group>

                                </b-form-group>
                            </div>   

                            <!--  border bottom color -->
                            <div class="setting">
                                <Mycolorpicker elementRef="borderBottomColorParent" theColorPicker="allpickers" colorPickerName="Color:" />
                            </div>

                            <!-- border bottom type -->
                            <div class="setting">
                                <b-form-group label="Style:">

                                    <b-form-select v-model="settingsFromWeebly.settings.borderBottomStyleParent" size="sm">

                                        <option value="solid">solid</option>

                                        <option value="dotted">dotted</option>

                                        <option value="dashed">dashed</option>

                                        <option value="double">double</option>

                                    </b-form-select>

                                </b-form-group>
                            </div>

                        </div><!-- border-group -->

                        <div class="border-group">

                            <div class="border-group--title">
                                Border left desktop
                            </div>
                            
                            <!--  border left width DESKTOP -->
                            <div class="setting">
                                <b-form-group>

                                    <label for="flexparent-borderLeftWidth-input">Width:</label>
                                    
                                    <b-input-group append="px" size="sm">
                                        <b-form-input id="flexparent-borderLeftWidth-input" type="number" v-model="settingsFromWeebly.settings.borderLeftWidthParent" min="0" />
                                    </b-input-group>

                                </b-form-group>
                            </div>   

                            <!--  border left color -->
                            <div class="setting">
                                <Mycolorpicker elementRef="borderLeftColorParent" theColorPicker="allpickers" colorPickerName="Color:" />
                            </div>

                            <!-- border left type -->
                            <div class="setting">
                                <b-form-group label="Style:">

                                    <b-form-select v-model="settingsFromWeebly.settings.borderLeftStyleParent" size="sm">

                                        <option value="solid">solid</option>

                                        <option value="dotted">dotted</option>

                                        <option value="dashed">dashed</option>

                                        <option value="double">double</option>

                                    </b-form-select>

                                </b-form-group>
                            </div>
                        </div><!-- border-group -->

                    </div><!-- v-if="parent.useIndividualBorder" -->  

                    <!-- border radius global -->
                    <div class="setting" v-show="deviceStylesSetttings.desktopStyles && settingsFromWeebly.settings.useBorderParent">
                        <b-form-group v-if="!settingsFromWeebly.settings.showBorderRadiusIndividual">

                            <label for="border-radius-global">Border radius:</label>

                            <i class="fas unlink-border-radius fa-link" @click="settingsFromWeebly.settings.showBorderRadiusIndividual = !settingsFromWeebly.settings.showBorderRadiusIndividual" v-b-tooltip.hover.top title="Click to set each radius different"></i>

                            <b-input-group append="px" size="sm">
                                <b-form-input id="border-radius-global" type="number" v-model="settingsFromWeebly.settings.borderRadiusGlobal" min="0" />
                            </b-input-group>

                        </b-form-group>
                    </div>

                    <!-- border left top -->
                    <div class="setting" v-if="settingsFromWeebly.settings.showBorderRadiusIndividual && deviceStylesSetttings.desktopStyles && settingsFromWeebly.settings.useBorderParent">
                        <b-form-group>
                            <label for="left-top-border">Left top border radius:</label>
                            <i class="fas unlink-border-radius fa-unlink" @click="settingsFromWeebly.settings.showBorderRadiusIndividual = !settingsFromWeebly.settings.showBorderRadiusIndividual"  v-b-tooltip.hover.top title="Click to set each radius equal"></i>

                            <b-input-group append="px" size="sm">
                                <b-form-input id="left-top-border" type="number" v-model="settingsFromWeebly.settings.borderRadiusLeftTop" min="0" />
                            </b-input-group>

                        </b-form-group>
                    </div>

                    <!-- border right top -->
                    <div class="setting" v-if="settingsFromWeebly.settings.showBorderRadiusIndividual && deviceStylesSetttings.desktopStyles && settingsFromWeebly.settings.useBorderParent">
                        <b-form-group label="Right top border radius:" label-for="right-top-border">
                            
                            <b-input-group append="px" size="sm">
                                <b-form-input id="right-top-border" type="number" v-model="settingsFromWeebly.settings.borderRadiusRightTop" min="0" />
                            </b-input-group>

                        </b-form-group>
                    </div>

                    <!-- border right bottom -->
                    <div class="setting" v-if="settingsFromWeebly.settings.showBorderRadiusIndividual && deviceStylesSetttings.desktopStyles && settingsFromWeebly.settings.useBorderParent">
                        <b-form-group label="Right bottom border radius [px]:" label-for="right-bottom-border">
                            
                            <b-input-group append="px" size="sm">
                                <b-form-input id="right-bottom-border" type="number" v-model="settingsFromWeebly.settings.borderRadiusRightBottom" min="0" />
                            </b-input-group>

                        </b-form-group>
                    </div>

                    <!-- border left bottom -->
                    <div class="setting" v-if="settingsFromWeebly.settings.showBorderRadiusIndividual && deviceStylesSetttings.desktopStyles && settingsFromWeebly.settings.useBorderParent">
                        <b-form-group label="Left bottom border radius:" label-for="left-bottom-border">
                            
                            <b-input-group append="px" size="sm">
                                <b-form-input id="left-bottom-border" type="number" v-model="settingsFromWeebly.settings.borderRadiusLeftBottom" min="0" />
                            </b-input-group>

                        </b-form-group>
                    </div>


                </div><!-- settings group -->

                <div class="setting" style="text-align: center;" v-show="deviceStylesSetttings.mobileStyles || deviceStylesSetttings.tabletStyles">
                    Styles are inherited from desktop/default styles
                </div>

            </b-tab>

            <!-- settings hover state -->
            <b-tab title="Hover" v-if="settingsFromWeebly.settings.linkTitle">

                 <!-- text color hover state -->
                <div class="settings-group-title">
                    <h6>content</h6>
                </div>

                <div class="settings-group">
                    <div class="setting">
                        <Mycolorpicker elementRef="textColorHover" theColorPicker="allpickers" colorPickerName="Text color:" />
                    </div>
                </div>

                <div class="settings-group-title">
                    <h6>style</h6>
                </div>

                <div class="settings-group">
                
                    <!-- background color hover state -->
                    <div class="setting">
                        <Mycolorpicker elementRef="buttonBgHover" theColorPicker="allpickers" colorPickerName="Background color:" />
                    </div>

                    <!-- border color hover state -->
                    <div class="setting">
                        <Mycolorpicker elementRef="borderColorHover" theColorPicker="allpickers" colorPickerName="Border color:" />
                    </div>
                </div>

            </b-tab>

        </b-tabs>
 
    </div>

</template>

<script>

import Mycolorpicker from './Mycolorpicker'
import MyIconPicker from '../elementSettings/Iconpicker'
                
export default {

    name: 'TitleSettings',

    data() {

        return{

            // for color picker
            colors: '#fff',

            // color pickers by default set to hide
            showBgPicker: false,
            showBgHoverPicker: false,
            showColorTextPicker: false,
            showColorTextHoverPicker: false,

            // hide additional options
            targetSettingsBox: false,

            // current color picker
            curColorPicker: '',
            curPicker: '',

            // see if user wants to specify a width set
            specifywidth: false,
            specifywidthTablet: false,
            specifywidthPhone: false,

            // settings for devices that need to be shown
            desktopSettings: true,
            tabletSettings: false,
            mobileSettings: false,

            activeIconOnLoad: ''
            
        } 

    },

    methods: {
  
        // apply font in css
        applyFont(event) {
        
            console.log(event)

            let font = event

            // load google font
            this.$store.state.weeblySettings.settings.fontGoogleLoad = font

            // convert font that equals id for checking checkbox
            font = font.split(':')

            let fontNameSplit = font[0]

            // remove possible + instances from fontNameSplit string
            if(fontNameSplit.includes('+')) {
                fontNameSplit = fontNameSplit.replace(/\+/g, " ")
                this.$store.state.weeblySettings.settings.fontFamily = '"'+fontNameSplit+'"'
            } else {
                this.$store.state.weeblySettings.settings.fontFamily = fontNameSplit
            }
            
            let fontStylePart = font[1]

            if( fontStylePart.includes('i') ) {
                let fontStylePartSplit = fontStylePart.split(/(i)/g)
                this.$store.state.weeblySettings.settings.fontStyle = 'italic'
                this.$store.state.weeblySettings.settings.fontWeight = fontStylePartSplit[0]
            } else {
                this.$store.state.weeblySettings.settings.fontWeight = fontStylePart
                this.$store.state.weeblySettings.settings.fontStyle = 'normal'
            }

        },

        // check for button width options DESKTOP
        checkButonWidthOptions() {

            // check active device
            if(this.$store.state.deviceStyles.tabletStyles) {
                // tablet is active
                console.log('inside tablet option')
                switch(event.target.value) {

                    case 'specifywidth':
                        console.log('inside tablet specifywidth')
                        // show input to specify width
                        this.specifywidthTablet = true

                        // check if need px for value - here we do need it
                        this.$store.state.weeblySettings.settings.setButtonWidthTablet = true

                        // value for max width and width
                        this.$store.state.weeblySettings.settings.buttonMaxWidthTablet = 150
                        this.$store.state.weeblySettings.settings.buttonWidthValueTablet = '100%'

                        break;

                    case 'fullwidthbutton':
                        console.log('inside tablet fullwidthbutton')
                        // hide input to specify width
                        this.specifywidthTablet = false

                        // check if need px for value - here we do not need it
                        this.$store.state.weeblySettings.settings.setButtonWidthTablet = false

                        // value for max width and width
                        this.$store.state.weeblySettings.settings.buttonMaxWidthTablet = 'none',
                        this.$store.state.weeblySettings.settings.buttonWidthValueTablet = '100%'
                        
                        break;

                    case 'auto':
                        console.log('inside tablet auto')
                        // hide input to specify width
                        this.specifywidthTablet = false

                        // check if need px for value - here we do not need it
                        this.$store.state.weeblySettings.settings.setButtonWidthTablet = false

                        // value for max width and width
                        this.$store.state.weeblySettings.settings.buttonMaxWidthTablet = 'none'
                        this.$store.state.weeblySettings.settings.buttonWidthValueTablet = 'auto'


                        break;

                    default: 
                        // hide input to specify width
                        this.specifywidthTablet = false

                        // check if need px for value - here we do not need it
                        this.$store.state.weeblySettings.settings.setButtonWidthTablet = false

                        // value for max width and width
                        this.$store.state.weeblySettings.settings.buttonMaxWidthTablet = 'none'
                        this.$store.state.weeblySettings.settings.buttonWidthValueTablet = 'auto'

                }

            } else if(this.$store.state.deviceStyles.mobileStyles) {
                // mobile is active
                console.log('in phone sets')
                switch(event.target.value) {

                    case 'specifywidth':

                        // show input to specify width
                        this.specifywidthPhone = true

                        // check if need px for value - here we do need it
                        this.$store.state.weeblySettings.settings.setButtonWidthPhone = true

                        // value for max width and width
                        this.$store.state.weeblySettings.settings.buttonMaxWidthPhone = 150
                        this.$store.state.weeblySettings.settings.buttonWidthValuePhone = '100%'
                        console.log('specifywidth options ran')
                        break;

                    case 'fullwidthbutton':
                        
                        // hide input to specify width
                        this.specifywidthPhone = false

                        // check if need px for value - here we do not need it
                        this.$store.state.weeblySettings.settings.setButtonWidthPhone = false

                        // value for max width and width
                        this.$store.state.weeblySettings.settings.buttonMaxWidthPhone = 'none',
                        this.$store.state.weeblySettings.settings.buttonWidthValuePhone= '100%'
                        console.log('fullwidthbutton options ran')
                        break;

                    case 'auto':
                    
                        // hide input to specify width
                        this.specifywidthPhone = false

                        // check if need px for value - here we do not need it
                        this.$store.state.weeblySettings.settings.setButtonWidthPhone = false

                        // value for max width and width
                        this.$store.state.weeblySettings.settings.buttonMaxWidthPhone = 'none'
                        this.$store.state.weeblySettings.settings.buttonWidthValuePhone = 'auto'
                        console.log('auto options ran')

                        break;

                    default: 
                        
                        // hide input to specify width
                        this.specifywidthPhone = false

                        // check if need px for value - here we do not need it
                        this.$store.state.weeblySettings.settings.setButtonWidthPhone = false

                        // value for max width and width
                        this.$store.state.weeblySettings.settings.buttonMaxWidthPhone = 'none'
                        this.$store.state.weeblySettings.settings.buttonWidthValuePhone = 'auto'

                }

            } else {
                // desktop is active
                console.log('now we need to run the desktop sets')
                switch(event.target.value) {

                    case 'specifywidth':

                        // show input to specify width
                        this.specifywidth = true

                        // check if need px for value - here we do need it
                        this.$store.state.weeblySettings.settings.setButtonWidth = true

                        // value for max width and width
                        this.$store.state.weeblySettings.settings.buttonMaxWidth = 150
                        this.$store.state.weeblySettings.settings.buttonWidthValue = '100%'

                        // set setwidth class for button
                        // this.$store.state.weeblySettings.settings.widthClass = 'setwidth'

                        console.log('specifywidth desktop: ', 'maxwidth: ', this.$store.state.weeblySettings.settings.buttonMaxWidth, 'width ',this.$store.state.weeblySettings.settings.buttonWidthValue )

                        break;

                    case 'fullwidthbutton':
                        
                        // hide input to specify width
                        this.specifywidth = false

                        // check if need px for value - here we do not need it
                        this.$store.state.weeblySettings.settings.setButtonWidth = false

                        // value for max width and width
                        this.$store.state.weeblySettings.settings.buttonMaxWidth = 'none',
                        this.$store.state.weeblySettings.settings.buttonWidthValue = '100%'

                        // set fullwidth class for button
                        // this.$store.state.weeblySettings.settings.widthClass = 'fullwidth'

                        console.log('fullwidthbutton desktop: ', 'maxwidth: ', this.$store.state.weeblySettings.settings.buttonMaxWidth, 'width ',this.$store.state.weeblySettings.settings.buttonWidthValue )
                        
                        break;

                    case 'auto':
                    
                    // hide input to specify width
                        this.specifywidth = false

                        // check if need px for value - here we do not need it
                        this.$store.state.weeblySettings.settings.setButtonWidth = false

                        // value for max width and width
                        this.$store.state.weeblySettings.settings.buttonMaxWidth = 'none'
                        this.$store.state.weeblySettings.settings.buttonWidthValue = 'auto'

                        // remove width class from button
                        // this.$store.state.weeblySettings.settings.widthClass = ''

                        console.log('auto desktop: ', 'maxwidth: ', this.$store.state.weeblySettings.settings.buttonMaxWidth, 'width ',this.$store.state.weeblySettings.settings.buttonWidthValue )

                        break;

                    default: 
                        // hide input to specify width
                        this.specifywidth = false

                        // check if need px for value - here we do not need it
                        this.$store.state.weeblySettings.settings.setButtonWidth = false

                        // remove width class from button
                        // this.$store.state.weeblySettings.settings.widthClass = ''

                        console.log('default: ', 'maxwidth: ', this.$store.state.weeblySettings.settings.buttonMaxWidth, 'width ',this.$store.state.weeblySettings.settings.buttonWidthValue )

                }
            }
            

        },

        // icon position update
        iconPositionUpdate() {

            if(event.target.value === 'useIconBefore') {

                this.$store.state.weeblySettings.settings.useIconBefore = true,
                this.$store.state.weeblySettings.settings.useIconAfter = false

            } else {

                this.$store.state.weeblySettings.settings.useIconBefore = false,
                this.$store.state.weeblySettings.settings.useIconAfter = true

            }

        },

        // show desktop settings
        switchDevice(event) {

            // remove active class from possible elements
            const icons = document.querySelectorAll('.device-selector--mini i');
            icons.forEach(icon => {
                icon.classList.remove('active')
            })
            
            // add active class to current
            event.target.classList.add('active');

            // set devices to false
            this.desktopSettings = false
            this.tabletSettings = false
            this.mobileSettings = false

            console.log(event.target.dataset.device)

            // set active settings to true
            this[event.target.dataset.device] = true

            if(event.target.dataset.device === 'tabletSettings') {
                this.$store.state.previewBoxWidth = '768px'
                this.$store.state.deviceStyles.mobileStyles = false
                this.$store.state.deviceStyles.tabletStyles = true
            } else if (event.target.dataset.device === 'mobileSettings') {
                this.$store.state.previewBoxWidth = '576px'
                this.$store.state.deviceStyles.tabletStyles = false
                this.$store.state.deviceStyles.mobileStyles = true
            } else {
                this.$store.state.previewBoxWidth = '100%'
                this.$store.state.deviceStyles.tabletStyles = false
                this.$store.state.deviceStyles.mobileStyles = false
            }

        }

    },

    components: {
       
        // color picker
        Mycolorpicker,

        // icon picker
        MyIconPicker

    },

    computed:{

        // get stored settings
        settingsFromWeebly() {
            return this.$store.state.weeblySettings
        },

        // google font picker
        googleFontsArray() {
            return this.$store.state.googleFontsToLoad
        },

        // device width return
        getCurrentDevice() {
            return this.$store.state.deviceStyles
        },

        // device Styles
        deviceStylesSetttings() {
            return this.$store.state.deviceStyles
        }
        

    },

    mounted() {

        // show additional options
        if(this.$store.state.weeblySettings.settings.buttonWidthSelect === "specifywidth"){

            this.specifywidth = true

        }

    }

}
</script>

<style lang="less">
@import '../../../less/colors.less';

.button-state-tabs {

    .nav {
        background: @light_blue;
        border: 1px solid @border_grey;
        border-radius: 0.25rem;
    }

    li.nav-item {
        flex: 1;
        text-align: center;
    }

    .tab-content {
        padding: 30px 0;
    }
}

span.button-target-settings-box-trigger {
    position: absolute;
    top: 0;
    right: 0;
    font-size: 12px;
    cursor: pointer;
}

.button-target-settings-box {
    position: absolute;
    background: #fff;
    padding: 10px;
    box-shadow: 0 3px 5px rgba(0,0,0,.2);
    width: 100%;
    left: 0;
    top: 70px;
    border-radius: 0.25rem;
    z-index: 20;
    border: 1px solid @border_grey;
}

.input-with-right-setting-icon {
    padding-right: 45px;
}

span.input-right-setting-icon {
    position: absolute;
    top: 27px;
    right: 1px;
    font-size: 11px;
    cursor: pointer;
    height: 27px;
    line-height: 27px;
    background: @light_blue;
    width: 30px;
    text-align: center;
    border-radius: 0 0.25rem 0.25rem 0;
    border-left: 1px solid @border_grey_dark;
}

.unlink-border-radius {
    position: absolute;
    top: 0;
    right: 0;
    width: 25px;
    height: 25px;
    line-height: 25px;
    text-align: center;
    margin-left: 5px;
    border-radius: 20px;
    cursor: pointer;
    background: @light_blue;
    font-size: 10px;
    display: inline-block;
    border: 1px solid @border_grey;
}

label.deactivated {
    opacity: .3;
}

</style>


// WEBPACK FOOTER //
// src/components/elements/elementSettings/TitleSettings.vue